import { render, staticRenderFns } from "./dla-kobiet.vue?vue&type=template&id=77154036&scoped=true&"
import script from "./dla-kobiet.vue?vue&type=script&lang=js&"
export * from "./dla-kobiet.vue?vue&type=script&lang=js&"
import style0 from "./dla-kobiet.vue?vue&type=style&index=0&id=77154036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77154036",
  null
  
)

export default component.exports